// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file tendermint/types/validator.proto (package tendermint.types, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { PublicKey } from "../crypto/keys_pb.js";
/**
 * @generated from message tendermint.types.ValidatorSet
 */
export class ValidatorSet extends Message {
    /**
     * @generated from field: repeated tendermint.types.Validator validators = 1;
     */
    validators = [];
    /**
     * @generated from field: tendermint.types.Validator proposer = 2;
     */
    proposer;
    /**
     * @generated from field: int64 total_voting_power = 3;
     */
    totalVotingPower = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "tendermint.types.ValidatorSet";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validators", kind: "message", T: Validator, repeated: true },
        { no: 2, name: "proposer", kind: "message", T: Validator },
        { no: 3, name: "total_voting_power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorSet().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorSet().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorSet().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorSet, a, b);
    }
}
/**
 * @generated from message tendermint.types.Validator
 */
export class Validator extends Message {
    /**
     * @generated from field: bytes address = 1;
     */
    address = new Uint8Array(0);
    /**
     * @generated from field: tendermint.crypto.PublicKey pub_key = 2;
     */
    pubKey;
    /**
     * @generated from field: int64 voting_power = 3;
     */
    votingPower = protoInt64.zero;
    /**
     * @generated from field: int64 proposer_priority = 4;
     */
    proposerPriority = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "tendermint.types.Validator";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "pub_key", kind: "message", T: PublicKey },
        { no: 3, name: "voting_power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "proposer_priority", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new Validator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Validator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Validator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Validator, a, b);
    }
}
/**
 * @generated from message tendermint.types.SimpleValidator
 */
export class SimpleValidator extends Message {
    /**
     * @generated from field: tendermint.crypto.PublicKey pub_key = 1;
     */
    pubKey;
    /**
     * @generated from field: int64 voting_power = 2;
     */
    votingPower = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "tendermint.types.SimpleValidator";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "pub_key", kind: "message", T: PublicKey },
        { no: 2, name: "voting_power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new SimpleValidator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimpleValidator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimpleValidator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SimpleValidator, a, b);
    }
}
